import { Stores } from "../modules"

export const StoresPages = () => {
  return (
    <Stores />
  )
}
